import styled from 'styled-components';
import InputFormField from '@/shared/ui/InputFormField';
import SubmitButton from '@/shared/ui/SubmitButton';
export const ModalContent = styled.section `
  position: relative;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  max-width: 360px;
  outline: none;
  width: 360px;

  @media screen and (max-width: 480px) {
    width: calc(100dvw - 16px);
  }
`;
export const ModalDescriptionWrapper = styled.section `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 12px;
  width: 100%;
`;
export const ModalTitleWrapper = styled.div `
  display: flex;
  gap: 12px;
`;
export const ModalTitleIcon = styled.img `
  width: 24px;
  height: 24px;
`;
export const ModalTitle = styled.h6 `
  font-family: Poppins;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
`;
export const ModalDescription = styled.p `
  font-family: Poppins;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
`;
export const ListModalDescription = styled.p `
  font-family: Poppins;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  position: relative;
  padding-left: 15px;

  strong {
    text-align: start;
  }

  span {
    color: #4b3a5a;
    text-decoration: underline;
  }

  &:nth-of-type(2),
  &:nth-of-type(4) {
    &::before {
      content: '•';
      position: absolute;
      left: 0;
      color: #4b3a5a;
      font-size: 18px;
    }
  }
`;
export const ContentActions = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-top: 12px;
  width: 100%;
`;
export const CloseButton = styled.button `
  width: 100%;
  height: 40px;
  border-radius: 4px;
  border-width: 1px;
  color: #a041ff;
  border-color: #a041ff;
  font-family: Poppins;
  font-weight: 500;
  font-size: 16px;
  background-color: white;
  text-align: center;
`;
export const NextButton = styled.button `
  width: ${({ width }) => width || '100%'};
  height: 40px;
  border-radius: 4px;
  color: white;
  border: none;
  background-color: #a041ff;
  font-family: Poppins;
  font-weight: 500;
  font-size: 16px;
  text-align: center;
`;
export const BackWrapper = styled.div `
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: end;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  text-align: center;
  margin-top: 10px;
`;
export const BackButton = styled.button `
  background-color: transparent;
  border: none;
  gap: 3px;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const FormWrapper = styled.form `
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 32px;
`;
export const Input = styled(InputFormField) `
  height: 42px;

  & .MuiInputBase-root {
    & .MuiInputBase-input {
      padding: 10px;
    }
  }
`;
export const Button = styled(SubmitButton) `
  height: 42px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  margin-top: 10px;

  box-shadow: 8px 8px 0px 0px #000000;
  &:hover,
  &:focus {
    box-shadow: 8px 8px 0px 0px black;
  }
`;
export const SendedEmailMessageWrapper = styled.div `
  width: 100%;
  padding: 12px;
  gap: 10px;
  width: 100%;
  border-radius: 8px;
  padding: 12px;

  border: 1px solid #a041ff;
  margin-bottom: 4px;
`;
export const MessageTitleWrapper = styled.p `
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
`;
export const MessageIcon = styled.img `
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
`;
export const MessageTitle = styled.p `
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  color: #a041ff;
`;
export const MessageDescription = styled.p `
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
  text-align: center;
  color: #a041ff;
`;
